import React, { useState, createContext, useContext } from 'react';
interface UserContextType {
  profileImage: string;
  setProfileImage: (url: string) => void;
  userData: {
    name: string;
    email: string;
    school: string;
    branch: string;
  };
  updateUserData: (data: Partial<UserContextType['userData']>) => void;
}
const defaultUserData = {
  profileImage: 'https://images.unsplash.com/photo-1568602471122-7832951cc4c5?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=facearea&facepad=2&w=300&h=300&q=80',
  setProfileImage: () => {},
  userData: {
    name: 'Ahmet Yılmaz',
    email: 'ahmet.yilmaz@okul.edu.tr',
    school: 'Atatürk Lisesi',
    branch: 'Matematik Öğretmeni'
  },
  updateUserData: () => {}
};
const UserContext = createContext<UserContextType>(defaultUserData);
export const UserProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const [profileImage, setProfileImage] = useState<string>(defaultUserData.profileImage);
  const [userData, setUserData] = useState(defaultUserData.userData);
  const updateUserData = (data: Partial<UserContextType['userData']>) => {
    setUserData(prev => ({
      ...prev,
      ...data
    }));
  };
  return <UserContext.Provider value={{
    profileImage,
    setProfileImage,
    userData,
    updateUserData
  }} data-id="element-2399">
      {children}
    </UserContext.Provider>;
};
export const useUser = () => useContext(UserContext);